import React from "react";
import { FaSync } from "react-icons/fa";
import styles from "./DelActions.module.css";

// Bottom Row Buttons

// Back to Table Button
// backToText is to indicate if we want the "Back to" in our button label
export const BackToTableButton = ({
  backToTableFunction,
  tableName,
  backToText = true,
}) => {
  return (
    <button className={styles.bottomRowButton} onClick={backToTableFunction}>
      Back to Table
    </button>
  );
};

// Save Draft Button
export const SaveDraftButton = ({ saveDraftFunction }) => {
  return (
    <button className={styles.bottomRowButton} onClick={saveDraftFunction}>
      Save
    </button>
  );
};

// Submit DEL Button
export const SubmitDelButton = ({ submitFunction }) => {
  return (
    <button className={styles.bottomRowButton} onClick={submitFunction}>
      Submit
    </button>
  );
};

// Approve DEL Button
export const ApproveDelButton = ({ approveFunction }) => {
  return (
    <button className={styles.bottomRowButton} onClick={approveFunction}>
      Approve
    </button>
  );
};

// Reject DEL Button
export const RejectDelButton = ({ rejectFunction }) => {
  return (
    <button className={styles.bottomRowRejectButton} onClick={rejectFunction}>
      Reject
    </button>
  );
};

// Show All Button
export const ShowAllButton = ({ showAllFunction, showAll }) => {
  return (
    <button className={styles.bottomRowButton} onClick={showAllFunction}>
      {showAll ? "Show Tabs" : "Show All"}
    </button>
  );
};

// Top Row Buttons

// New DEL Button
export const NewDelButton = ({ newDelFunction }) => {
  return (
    <button className={styles.delButton} onClick={newDelFunction}>
      New DEL
    </button>
  );
};

// Edit Draft Button
export const EditDraftButton = ({ editFunction, disabled = false }) => {
  return (
    <button
      className={styles.delButton}
      onClick={() => {
        if (!disabled) editFunction();
      }}
      disabled={disabled}
      title={disabled ? "Edit not available" : undefined}
    >
      Edit
    </button>
  );
};

// Copy DEL Button
export const CopyDelButton = ({ copyFunction, disabled = false }) => {
  return (
    <button
      className={styles.delButton}
      onClick={copyFunction}
      disabled={disabled}
      title={disabled ? "Select a DEL to copy" : undefined}
    >
      Copy
    </button>
  );
};

// View DEL Button
export const ViewDelButton = ({ viewFunction, disabled = false }) => {
  return (
    <button
      className={styles.delButton}
      onClick={viewFunction}
      disabled={disabled}
      title={disabled ? "Select a DEL to view" : undefined}
    >
      View
    </button>
  );
};

// Transfer DEL Button
export const TransferDelButton = ({ showTransferDelModal }) => {
  return (
    <button className={styles.delButton} onClick={showTransferDelModal}>
      Transfer
    </button>
  );
};

// Transfer DEL to Different Approver Button
export const TransferDelToDifferentApproverButton = ({
  showTransferDelModal,
}) => {
  return (
    <button className={styles.delButton} onClick={showTransferDelModal}>
      Change Approver
    </button>
  );
};

// Approve Button at the top of the screen to choose to look at a del, not to be confused with the Approve DEL Button which actually approves a del.
export const ApproveButton = ({ approveFunction, disabled = false }) => {
  return (
    <button
      className={styles.delButton}
      onClick={approveFunction}
      disabled={disabled}
      title={disabled ? "Approval not available" : undefined}
    >
      Approve
    </button>
  );
};

// Desktop only PDF Button
export const DownloadPdfButton = ({ onClick, disabled = false }) => {
  return (
    <button
      className={`${styles.delButton} ${styles.desktopOnly}`}
      onClick={onClick}
      disabled={disabled}
      title="Download checked DELs"
    >
      PDFs
    </button>
  );
};

// Filter Button for the Reporting Table
export const FilterButton = ({ filterFunction }) => {
  return (
    <button className={styles.delButton} onClick={filterFunction}>
      ☰ Filters
    </button>
  );
};

// DEL Lists Refresh Button - for refreshing data in each tab
export const RefreshDelListsButton = ({
  refreshFunction,
  isLoading = false,
}) => {
  return (
    <button
      className={`${styles.refreshButton} ${isLoading ? styles.loading : ""}`}
      onClick={refreshFunction}
      disabled={isLoading}
      title="Refresh DEL lists from server"
    >
      <FaSync className={isLoading ? styles.spinning : ""} />
      {"Refresh"}
    </button>
  );
};

export const UnapproveDelButton = ({ unapproveFunction }) => {
  return (
    <button className={styles.delButton} onClick={unapproveFunction}>
      Unapprove
    </button>
  );
};
